// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"16":"7e8b496d","17":"7729902e","23":"fc85de2e","54":"0e9a6bfc","102":"fb194ec9","182":"07ece654","274":"4eeec535","387":"92d41436","418":"3f0793a4","469":"718eff6c","496":"c53690f0","635":"544a4b06","915":"5dbcca1b"}[chunkId] + ".js";
};